// Breadcrumb scroller (touch layout): keeps the fade edges in sync with the
// scroll position and re-asserts the scrolled-to-end start position once
// webfonts have settled (font swap changes the list width; without this the
// initial end position — set by the inline script in the section for a
// flash-free first paint — can end up a few pixels off).
class JgdBreadcrumbNav extends HTMLElement {
  #list = null;

  connectedCallback() {
    this.#list = this.querySelector('.jgd-breadcrumb__list');
    if (!this.#list) return;

    this.#list.addEventListener('scroll', this.#update, { passive: true });
    window.addEventListener('resize', this.#update, { passive: true });

    this.#scrollToEnd();
    this.#update();

    document.fonts?.ready.then(() => {
      if (!this.isConnected) return;
      // Only re-snap if the user hasn't scrolled away from the end yet.
      if (this.#distanceToEnd() < 24) this.#scrollToEnd();
      this.#update();
    });
  }

  disconnectedCallback() {
    this.#list?.removeEventListener('scroll', this.#update);
    window.removeEventListener('resize', this.#update);
  }

  #distanceToEnd() {
    const el = this.#list;
    return el.scrollWidth - el.clientWidth - el.scrollLeft;
  }

  #scrollToEnd() {
    this.#list.scrollLeft = this.#list.scrollWidth;
  }

  #update = () => {
    const el = this.#list;
    const max = el.scrollWidth - el.clientWidth;
    this.toggleAttribute('data-fade-start', max > 1 && el.scrollLeft > 1);
    this.toggleAttribute('data-fade-end', max > 1 && el.scrollLeft < max - 1);
  };
}

if (!customElements.get('jgd-breadcrumb-nav')) {
  customElements.define('jgd-breadcrumb-nav', JgdBreadcrumbNav);
}
